export enum ParentQuestionType {
  CheckBox = 1,
  Dropdown = 2,
  Text = 3,
}

// tslint:disable-next-line:interface-name
export interface ParentQuestion {
  title: string;
  subTitle: string;
  questionsType: ParentQuestionType;
  options: Array<{
    label: string;
    value: string | boolean;
    order: number;
    id: string;
  }>;
  answer: string;
  order: number;
  isRequired: boolean;
  id: string;
}



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/event-page-models/parent-question.ts